const languageObj = {
  "Mute Video": "كتم الفيديو",
  "HitPaw Online Mute Video": "كتم الفيديو على الإنترنت HitPaw",
  "Fast and easy to remove sound from your video online": "سريع وسهل لإزالة الصوت من الفيديو خاصتك على الإنترنت",
  "Muting": "جاري الكتم",
  "Mute Failed": "فشل كتم",
  "Mute New": "كتم جديد"
};

export default languageObj